import React from 'react';
import { PropTypes, describe } from 'react-desc';

/* eslint-disable react/no-unused-prop-types */

var DSTab = function DSTab(_ref) {
  var _ref$tabId = _ref.tabId,
      tabId = _ref$tabId === void 0 ? '' : _ref$tabId,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": "".concat(tabId, "-label"),
    tabId: tabId,
    title: title,
    required: required
  });
};

DSTab.displayName = 'DSTab';
var props = {
  /** unique id for tab */
  tabId: PropTypes.string.description('unique id for tab'),

  /** tab title */
  title: PropTypes.string.description('tab title'),

  /** Show a required mark next to the title */
  required: PropTypes.bool.description('Show a required mark next to the title'),

  /** Whether or not it's a ds-tab from DSMobile tabs */
  isDSMobile: PropTypes.bool.description("Whether or not it's a ds-tab from DSMobile tabs")
};
DSTab.propTypes = props;
var DSTabWithSchema = describe(DSTab);
DSTabWithSchema.propTypes = props;

export default DSTab;
export { DSTab, DSTabWithSchema };
//# sourceMappingURL=DSTab.js.map
